import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const spanStyle = {
  marginLeft: '3px',
  color: 'red',
  fontWeight: 'bold',
}

class Requests extends React.Component {
  constructor(props) {
    super(props)
    this.state = { number: props.no }
  }

  componentDidMount(){
    this.timer = setInterval(() => this.getCount(), 30000)
  }

  async getCount(){
    const res = this.props.id.split('/')
    const ourUrl = '/api/v1/get_requests_count/' + res[2]
    fetch(ourUrl, {method: 'GET'})
    .then((response) => response.json())
    .then((responseData) => {
      this.setState({ number: responseData['no_requests']})
    })
    .catch((error) => {
      console.error(error)
    })
  }

  render() {
    return <span style={spanStyle}>{this.state.number}</span>
  }
}

Requests.propTypes = {
  no: PropTypes.string,
  id: PropTypes.string,
}

export default Requests
